'use client';
import classNames from 'classnames/bind';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { TOAST_BOTTOM_PADDING_BASE } from '../../constants/toast.mjs';
import styles from './ToastWrapper.module.scss.mjs';

const cx = classNames.bind(styles);
function ToastWrapper(_ref) {
  let {
    children,
    duration,
    destroy,
    animation,
    bottomPaddingBase = TOAST_BOTTOM_PADDING_BASE.BASIC
  } = _ref;
  const [startTransform, setStartTransform] = useState();
  const $timeoutID = useRef(null);
  const $container = useRef(null);
  const handleDestroy = useCallback(async () => {
    var _$container$current;
    if ($timeoutID.current) {
      clearTimeout($timeoutID.current);
      $timeoutID.current = null;
    }
    setStartTransform(false);
    (_$container$current = $container.current) === null || _$container$current === void 0 || _$container$current.addEventListener('transitionend', destroy, {
      once: true
    });
  }, [destroy]);
  useEffect(() => {
    setStartTransform(true);
    /**
     * duration < 0 : handleDestroy 실행 X (ToastAction은 auto-close하지 않음)
     * duration = 0 : handleDestroy 즉시 실행 (close)
     * duration > 0 : duration 밀리초 후 handleDestroy 실행 (ToastNotice)
     */
    if (duration >= 0) {
      $timeoutID.current = setTimeout(handleDestroy, duration);
    }
    return () => {
      if ($timeoutID.current) {
        clearTimeout($timeoutID.current);
        $timeoutID.current = null;
      }
    };
  }, [duration, handleDestroy]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', animation, {
      'ani-active': startTransform
    }, `bottom-position-${bottomPaddingBase}`),
    ref: $container
  }, children);
}

export { ToastWrapper as default };
